const RESOURCE_NAME = "entities/walletChargeSubscriptions";

export default {};
